webpackJsonp([224200277164179],{

/***/ 1205:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"htmlAst":{"type":"root","children":[{"type":"element","tagName":"h2","properties":{},"children":[{"type":"text","value":"Uitleg"}]},{"type":"text","value":"\n"},{"type":"element","tagName":"p","properties":{},"children":[{"type":"text","value":"De "},{"type":"element","tagName":"strong","properties":{},"children":[{"type":"text","value":"superlativus"}]},{"type":"text","value":" komt overeen met de "},{"type":"element","tagName":"a","properties":{"href":"18a"},"children":[{"type":"element","tagName":"em","properties":{},"children":[{"type":"text","value":"overtreffende trap"}]}]},{"type":"text","value":", bijvoorbeeld ‘grootst’."}]}],"data":{"quirksMode":false}},"frontmatter":{"book":"spqr","leerdoel":"18f","title":"Leerdoel 18f"}}},"pathContext":{"slug":"/spqr/leerdoelen/18f/","title":"Leerdoel 18f"}}

/***/ })

});


// WEBPACK FOOTER //
// path---spqr-leerdoelen-18-f-4c5e834baa2dafe5d75a.js